import PropTypes from 'prop-types'
import React from 'react'

import Image from 'styles/components/Image'
import { Text } from 'styles/components/typography'

import foodBasket from './assets/food_basket.svg'
import { SectionWrapperStyled } from './styles'

const BNutritionDiet = ({ data }) => {
  return (
    <SectionWrapperStyled withIndents={true}>
      <div className="row align-items-center py-2 py-md-5">
        <div className="col-md-4">
          <Text dangerouslySetInnerHTML={{ __html: data.content_left }} />
        </div>
        <div className="col-md-4">
          <Image
            maxWidth={280}
            className="my-5 my-md-0 mx-auto"
            src={foodBasket}
            alt="food basket"
          />
        </div>
        <div className="col-md-4">
          <Text dangerouslySetInnerHTML={{ __html: data.content_right }} />
        </div>
      </div>
    </SectionWrapperStyled>
  )
}

BNutritionDiet.propTypes = {
  data: PropTypes.object.isRequired,
}

export default BNutritionDiet
